module.exports = __webpack_public_path__ + "img/08_choice 4.5ed6dc53.png";